{
  "ACTIONS": {
    "CONFIRM": "确认",
    "CONTINUE": "继续",
    "SUBMIT": "提交",
    "RETRY": "重试",
    "CANCEL": "取消",
    "EMPTY": "未找到",
    "LOADING_ORDERS": "正在准备您的账单",
    "CLEAR_ALL": "Clear All",
    "AWESOME": "Awesome!",
    "VIEW_RECEIPT": "The Receipt",
    "ADD_CART": "Add to Cart",
    "UPDATE_CART": "更新购物车",
    "EDIT": "编辑",
    "SEARCH_PLACEHOLDER": "Search for food or restaurants"
  },
  "COMMON": {
    "CALORIES": "Cal. {{calories}}",
    "MISSING_SELECTIONS": "Some options are missing, please select before proceeding",
    "ITEM_UNAVAILABLE": "This item is currently not available",
    "SECTION_NOT_FOUND": "此分类已不再提供",
    "ITEM_NOT_FOUND": "此商品已不再提供",
    "PROMOTION_NOT_AVAILABLE": "此优惠活动已不再提供",
    "REQUIRED": "Required",
    "COMBO": "套餐",
    "INVALID_EMAIL": "请输入有效的电子邮箱地址",
    "INVALID_PHONE": "请输入有效的手机号码",
    "FEES": "Fees",
    "MIN_ORDER_ERROR": "Minimum order value of {{currency}} {{amount}} is required to place your order",
    "ADD_MIN_ORDER": "Add {{currency}} {{amount}} to place your order",
    "CONNECTION_ERROR": "加载此餐桌时出现问题，请重试。",
    "TABLE_NOT_FOUND": "未找到此餐桌，请重新扫描二维码。"
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Last Name",
    "ROOM_NUMBER": "Room Number",
    "SNACKBAR_TITLE": "Your bill is on the way",
    "PAY_BILL": "付款"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "餐桌总人数",
    "PAYING_FOR": "您要支付的人数",
    "REMAINING": "剩余金额",
    "CHEQUE": "账单",
    "AMOUNT_PAID": "已付金额",
    "DISCOUNT": "折扣",
    "PROMO": "促销",
    "FEES": "费用",
    "PAID_ITEMS": "已付商品",
    "SPLIT_BILL": "分摊账单",
    "EDIT_SPLIT": "编辑分摊",
    "PAY_BILL": "支付账单",
    "SPLIT_TITLE": "分摊账单",
    "SPLIT_SUBTITLE": "请选择您希望如何分摊账单",
    "SPLIT_EVENLY": "平均分摊",
    "CUSTOM_AMOUNT": "自定义金额",
    "ADD_CUSTOM_AMOUNT": "添加自定义金额",
    "CUSTOM_AMOUNT_PLACEHOLDER": "输入自定义金额",
    "PAY_FOR_ITEMS": "支付您的商品",
    "CONFIRM_SELECTION": "确认选择",
    "SOMEONE_ELSE_PAYING": "您桌上的其他人正在付款"
  },
  "COMBO": {
    "ADD_N": "添加 {{count}} 个{{section}}",
    "REMOVE_N": "移除 {{count}} 个{{section}}",
    "CANNOT_PROCEED": "请按照上方指引完成套餐选择后再继续",
    "COMPLETE": "{{combo}}套餐已选择完成！",
    "ON_ANOTHER_SECTION": "这是您的{{section}}套餐的一部分"
  },
  "CART": {
    "TITLE": "已点餐详情",
    "RECOMMENDATION": "猜你喜欢",
    "TOTAL": "总计",
    "VIEW": "查看当前已点餐 & 确认",
    "EMPTY": "没有已选餐",
    "PLACE_ORDER": "确认",
    "ADD_TO_BILL": "添加到账单",
    "PAY_NOW": "立即支付",
    "OOPS": "系统出现问题",
    "ADD_NEW_VARIANT": "再添加一个",
    "VARIANT_TITLE": "改变主意了？",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Are you sure you want to clear the cart?",
    "CLEAR": "Clear Cart",
    "ADD_NOTE": "ADD A NOTE",
    "NOTE_LABEL": "Note"
  },
  "PAYMENT": {
    "CONFIRMED": "Your order has been paid !",
    "ERROR": "An error occurred during payment, please try again",
    "APPLE_PAY_TAP_AGAIN": "Please tap Apple Pay again to continue",
    "TITLE": "付款",
    "PAY_CARD": "Checkout",
    "SUCCESSFUL": "Payment Was Successful",
    "SUMMARY": "Payment Summary",
    "PROGRESS": "Payment in progress..., please wait",
    "CANCEL": "Please do not refresh this page or click on the back button. If you wish to cancel, please press the cancel button on the payment machine."
  },
  "ORDER": {
    "TITLE": "我的点餐",
    "CONFIRMED": "Confirmed",
    "NOTES": "Order Notes",
    "TOTAL": "总计",
    "SUBTOTAL": "Subtotal",
    "ORDER": "点餐",
    "PAID": "Paid",
    "PLACED": "Your Order Has Been Placed",
    "UNPAID": "您的订单尚未支付",
    "CANCELLED": "您的订单已取消",
    "VOID": "您的订单已作废",
    "UPDATED": "您的订单已更新",
    "ORDERS": "Orders",
    "PREVIOUS": "Previous Orders",
    "REJECTED": "Oops! One or more items or modifiers are currently unavailable and have been removed from your cart."
  },
  "WAITER": {
    "SNACKBAR_TITLE": "We'll be with you shortly",
    "HELP": "需求?",
    "ADDITIONAL_COMMENTS": "Comments"
  },
  "MENU": {
    "SKIP": "跳过",
    "MENU": "菜单",
    "SEARCH": "搜索",
    "NO_SEARCH_RESULTS": "未找到符合搜索条件的商品",
    "SEARCH_OTHER_SECTIONS": "在其他分类中找到了匹配项",
    "NO_FILTER_RESULTS": "没有符合筛选条件的菜品",
    "CLEAR_FILTERS": "清除筛选",
    "NO_SECTIONS": "暂无可用分类",
    "STAFF": "呼叫服务员",
    "FILTERS": "Dietery Filters"
  },
  "SETTINGS": {
    "TITLE": "设置",
    "LANGUAGE": "语言",
    "SELECT_LANGUAGE": "选择语言",
    "CURRENCY": "Currency"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "消费计入房费"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "Please rescan the QR to continue your session",
    "SESSION_EXPIRED": "Your session has expired"
  },
  "PICKUP": {
    "TITLE": "Your Details"
  },
  "VOUCHER": {
    "ADD": "Add a Voucher",
    "PLACEHOLDER": "输入您的优惠券",
    "VOUCHER": "Voucher",
    "DISCOUNTED_AMOUNT": "Total After Discount",
    "CURRENT_BALANCE": "Balance",
    "REMAINING_BALANCE": "Balance After Purchase",
    "AMOUNT_DUE": "Amount Due"
  },
  "TIP": {
    "TIP": "小费",
    "ADD": "添加小费",
    "PLACEHOLDER": "输入小费金额"
  },
  "LANDING": {
    "CALL_WAITER": "呼叫服务员",
    "VIEW_BILL": "查看账单 - ",
    "LOADING_BILL": "正在加载账单"
  },
  "LOADER": {
    "Heading": "正在处理您的付款...",
    "Subheading": "请勿关闭此页面。我们正在确认您的付款，并将自动为您跳转。",
    "Hint": "这通常需要几秒钟。"
  },
  "NoVoucher": "优惠券不可用",
  "VoucherDisabled": "此优惠券已停用",
  "VoucherExpired": "此优惠券已过期",
  "VoucherAlreadyUsed": "此优惠券已被使用",
  "VoucherZeroBalance": "此优惠券余额为 0",
  "VoucherUserLimitReached": "您已使用过此优惠券",
  "VoucherFirstOrderOnly": "此优惠券仅适用于您的首次订单",
  "VoucherNotApplicable": "此优惠券不适用于您订单中的商品"
}
